import { Controller } from '@hotwired/stimulus'
import { useDebounce, useWindowResize } from 'stimulus-use'

export default class extends Controller {
    // static debounces = ['autogrow']

    static values = {
        resizeDebounceDelay: {
          type: Number,
          default: 100
        }
      }

    connect() {
        useDebounce(this)
        useWindowResize(this)

        this.element.style.resize = 'none'
        this.element.style.overflow = 'hidden'

        this.autogrow()
        
        this.element.addEventListener('input', this.autogrow.bind(this))
    }
    
    windowResize() {
        this.autogrow()
    }
    
    autogrow() {
        this.element.style.height = 'auto' // Force re-print before calculating the scrollHeight value.
        this.element.style.height = `${this.element.scrollHeight + 16}px`
    }
    
    disconnect() {
        this.element.removeEventListener('input', this.autogrow.bind(this))
    }

}